import { isMobile } from '@core/mobile/isMobile';
import type { ThemeV2 } from './types/themeTypes';

export const DEFAULT_LIGHT_THEME: DefaultTheme = 'Macro Light';
export const DEFAULT_DARK_THEME: DefaultTheme = 'Macro Dark';

const MACRO_DARK: Pick<ThemeV2, 'depth' | 'tokens' | 'overrides'> = isMobile()  ? {
      depth: 0.35,
      tokens: {
        a0: { l: 0.75, c: 0.20, h:  59 },
        a1: { l: 0.75, c: 0.20, h:  99 },
        a2: { l: 0.75, c: 0.20, h: 139 },
        a3: { l: 0.75, c: 0.20, h: 179 },
        a4: { l: 0.75, c: 0.20, h: 219 },
        b0: { l: 0.00, c: 0.00, h:  21 },
        b1: { l: 0.18, c: 0.00, h:  21 },
        b2: { l: 0.23, c: 0.00, h:  21 },
        b3: { l: 0.25, c: 0.00, h:  21 },
        b4: { l: 0.28, c: 0.00, h:  21 },
        c0: { l: 0.95, c: 0.00, h:  21 },
        c1: { l: 0.83, c: 0.00, h:  21 },
        c2: { l: 0.75, c: 0.00, h:  21 },
        c3: { l: 0.63, c: 0.00, h:  21 },
        c4: { l: 0.55, c: 0.00, h:  21 },
      },
    }
  : {
      depth: 0.15,
      tokens: {
        a0: { l: 0.75, c: 0.20, h:  59 },
        a1: { l: 0.75, c: 0.20, h:  99 },
        a2: { l: 0.75, c: 0.20, h: 139 },
        a3: { l: 0.75, c: 0.20, h: 179 },
        a4: { l: 0.75, c: 0.20, h: 219 },
        b0: { l: 0.14, c: 0.00, h:  59 },
        b1: { l: 0.20, c: 0.00, h:  59 },
        b2: { l: 0.23, c: 0.00, h:  59 },
        b3: { l: 0.25, c: 0.00, h:  59 },
        b4: { l: 0.28, c: 0.00, h:  59 },
        c0: { l: 0.95, c: 0.00, h:  59 },
        c1: { l: 0.83, c: 0.00, h:  59 },
        c2: { l: 0.75, c: 0.00, h:  59 },
        c3: { l: 0.63, c: 0.00, h:  59 },
        c4: { l: 0.55, c: 0.00, h:  59 },
      },
    };

const MACRO_LIGHT: Pick<ThemeV2, 'depth' | 'tokens' | 'overrides'> = isMobile()
  ? {
      depth: 0.06,
      tokens: {
        a0: { l: 0.65, c: 0.20, h:  59 },
        a1: { l: 0.65, c: 0.20, h:  99 },
        a2: { l: 0.65, c: 0.20, h: 139 },
        a3: { l: 0.65, c: 0.20, h: 179 },
        a4: { l: 0.65, c: 0.20, h: 219 },
        b0: { l: 1.00, c: 0.00, h:  59 },
        b1: { l: 0.96, c: 0.00, h:  59 },
        b2: { l: 0.96, c: 0.00, h:  59 },
        b3: { l: 0.92, c: 0.00, h:  59 },
        b4: { l: 0.91, c: 0.00, h:  59 },
        c0: { l: 0.14, c: 0.00, h:  59 },
        c1: { l: 0.40, c: 0.00, h:  59 },
        c2: { l: 0.55, c: 0.00, h:  59 },
        c3: { l: 0.65, c: 0.00, h:  59 },
        c4: { l: 0.75, c: 0.00, h:  59 },
      },
      overrides: [
        {
          token: 'menu',
          value: { l: 1.00, c: 0.00, h:  59 },
        },
        {
          token: 'panel',
          value: { l: 1.00, c: 0.00, h:  59 },
        },
        {
          token: 'dialog',
          value: { l: 1.00, c: 0.00, h:  59 },
        },
        {
          token: 'input',
          value: { l: 1.00, c: 0.00, h:  59 },
        },
      ]
    }
  : {
      depth: 0.16,
      tokens: {
        a0: { l: 0.65, c: 0.20, h:  59 },
        a1: { l: 0.65, c: 0.20, h:  99 },
        a2: { l: 0.65, c: 0.20, h: 139 },
        a3: { l: 0.65, c: 0.20, h: 179 },
        a4: { l: 0.65, c: 0.20, h: 219 },
        b0: { l: 0.964, c: 0.00, h:  59 },
        b1: { l: 0.92, c: 0.00, h:  59 },
        b2: { l: 0.91, c: 0.00, h:  59 },
        b3: { l: 0.92, c: 0.00, h:  59 },
        b4: { l: 0.91, c: 0.00, h:  59 },
        c0: { l: 0.16, c: 0.00, h:  59 },
        c1: { l: 0.40, c: 0.00, h:  59 },
        c2: { l: 0.45, c: 0.00, h:  59 },
        c3: { l: 0.55, c: 0.00, h:  59 },
        c4: { l: 0.70, c: 0.00, h:  59 },
      },
    };


// Ordered for the theme picker: dark themes first (led by the Macro brand theme),
// then light themes (led by the Macro brand theme). ThemeList renders in array order.
export const DEFAULT_THEMES = [
  {
    id: 'Macro Dark',
    name: 'Macro Dark',
    version: 2,
    depth: MACRO_DARK.depth,
    tokens: MACRO_DARK.tokens,
    overrides: MACRO_DARK.overrides
  },
  {
    // Neutral anchor: a true graphite monochrome, accents carry only a whisper of
    // cool hue so categorical charts stay distinguishable without breaking the grey.
    id: "Void",
    name: "Void",
    version: 2,
    depth: 0.18,
    tokens: {
      a0: { l: 0.80, c: 0.03, h: 250 },
      a1: { l: 0.80, c: 0.03, h: 290 },
      a2: { l: 0.80, c: 0.03, h: 330 },
      a3: { l: 0.80, c: 0.03, h:  10 },
      a4: { l: 0.80, c: 0.03, h:  50 },
      b0: { l: 0.15, c: 0.00, h:   0 },
      b1: { l: 0.19, c: 0.00, h:   0 },
      b2: { l: 0.22, c: 0.00, h:   0 },
      b3: { l: 0.25, c: 0.00, h:   0 },
      b4: { l: 0.29, c: 0.00, h:   0 },
      c0: { l: 0.95, c: 0.00, h:   0 },
      c1: { l: 0.82, c: 0.00, h:   0 },
      c2: { l: 0.72, c: 0.00, h:   0 },
      c3: { l: 0.63, c: 0.00, h:   0 },
      c4: { l: 0.55, c: 0.00, h:   0 },
    },
  },
  {
      // Warm: a deep ember charcoal with a soft amber accent.
      id: 'Ember',
      name: 'Ember',
      version: 2,
      depth: 0.12,
      tokens: {
        a0: { l: 0.75, c: 0.15, h:  55 },
        a1: { l: 0.75, c: 0.15, h:  95 },
        a2: { l: 0.75, c: 0.15, h: 135 },
        a3: { l: 0.75, c: 0.15, h: 175 },
        a4: { l: 0.75, c: 0.15, h: 215 },
        b0: { l: 0.16, c: 0.010, h:  55 },
        b1: { l: 0.20, c: 0.010, h:  55 },
        b2: { l: 0.24, c: 0.012, h:  55 },
        b3: { l: 0.27, c: 0.012, h:  55 },
        b4: { l: 0.31, c: 0.014, h:  55 },
        c0: { l: 0.95, c: 0.008, h:  55 },
        c1: { l: 0.83, c: 0.008, h:  55 },
        c2: { l: 0.73, c: 0.008, h:  55 },
        c3: { l: 0.63, c: 0.008, h:  55 },
        c4: { l: 0.55, c: 0.008, h:  55 },
      },
    },
  {
    // Cool: an ethereal violet-indigo night, calm and a touch mysterious.
    id: 'Spirit',
    name: 'Spirit',
    version: 2,
    depth: 0.20,
    tokens: {
      a0: { l: 0.72, c: 0.16, h: 295 },
      a1: { l: 0.72, c: 0.16, h: 335 },
      a2: { l: 0.72, c: 0.16, h:  15 },
      a3: { l: 0.72, c: 0.16, h:  55 },
      a4: { l: 0.72, c: 0.16, h:  95 },
      b0: { l: 0.16, c: 0.014, h: 295 },
      b1: { l: 0.20, c: 0.014, h: 295 },
      b2: { l: 0.24, c: 0.016, h: 295 },
      b3: { l: 0.27, c: 0.016, h: 295 },
      b4: { l: 0.31, c: 0.018, h: 295 },
      c0: { l: 0.93, c: 0.012, h: 295 },
      c1: { l: 0.84, c: 0.012, h: 295 },
      c2: { l: 0.74, c: 0.012, h: 295 },
      c3: { l: 0.64, c: 0.012, h: 295 },
      c4: { l: 0.56, c: 0.012, h: 295 },
    },
  },
  {
    // Cool: a deep midnight blue with a periwinkle accent — quiet and nocturnal.
    id: 'Moon',
    name: 'Moon',
    version: 2,
    depth: 0.15,
    tokens: {
      a0: { l: 0.70, c: 0.15, h: 255 },
      a1: { l: 0.70, c: 0.15, h: 295 },
      a2: { l: 0.70, c: 0.15, h: 335 },
      a3: { l: 0.70, c: 0.15, h:  15 },
      a4: { l: 0.70, c: 0.15, h:  55 },
      b0: { l: 0.15, c: 0.012, h: 255 },
      b1: { l: 0.19, c: 0.012, h: 255 },
      b2: { l: 0.23, c: 0.014, h: 255 },
      b3: { l: 0.26, c: 0.014, h: 255 },
      b4: { l: 0.30, c: 0.016, h: 255 },
      c0: { l: 0.95, c: 0.010, h: 255 },
      c1: { l: 0.85, c: 0.010, h: 255 },
      c2: { l: 0.75, c: 0.010, h: 255 },
      c3: { l: 0.65, c: 0.010, h: 255 },
      c4: { l: 0.57, c: 0.010, h: 255 },
    },
  },
  {
    // Cool: a slate teal, like rain on glass — muted, fresh, easy on the eyes.
    id: 'Rain',
    name: 'Rain',
    version: 2,
    depth: 0.13,
    tokens: {
      a0: { l: 0.72, c: 0.13, h: 200 },
      a1: { l: 0.72, c: 0.13, h: 240 },
      a2: { l: 0.72, c: 0.13, h: 280 },
      a3: { l: 0.72, c: 0.13, h: 320 },
      a4: { l: 0.72, c: 0.13, h: 360 },
      b0: { l: 0.15, c: 0.010, h: 210 },
      b1: { l: 0.19, c: 0.010, h: 210 },
      b2: { l: 0.23, c: 0.012, h: 210 },
      b3: { l: 0.26, c: 0.012, h: 210 },
      b4: { l: 0.30, c: 0.014, h: 210 },
      c0: { l: 0.94, c: 0.008, h: 210 },
      c1: { l: 0.84, c: 0.008, h: 210 },
      c2: { l: 0.74, c: 0.008, h: 210 },
      c3: { l: 0.64, c: 0.008, h: 210 },
      c4: { l: 0.56, c: 0.008, h: 210 },
    },
  },
  {
    id: 'Macro Light',
    name: 'Macro Light',
    version: 2,
    depth: MACRO_LIGHT.depth,
    tokens: MACRO_LIGHT.tokens,
    overrides: MACRO_LIGHT.overrides
  },
  {
    // Warm: a cream page with a sun-ripe orange accent — citrus, but restrained.
    id: 'Satsuma',
    name: 'Satsuma',
    version: 2,
    depth: 0.06,
    tokens: {
      a0: { l: 0.62, c: 0.16, h:  55 },
      a1: { l: 0.62, c: 0.16, h:  95 },
      a2: { l: 0.62, c: 0.16, h: 135 },
      a3: { l: 0.62, c: 0.16, h: 175 },
      a4: { l: 0.62, c: 0.16, h: 215 },
      b0: { l: 0.98, c: 0.008, h:  70 },
      b1: { l: 0.96, c: 0.010, h:  70 },
      b2: { l: 0.93, c: 0.012, h:  65 },
      b3: { l: 0.95, c: 0.010, h:  65 },
      b4: { l: 0.93, c: 0.012, h:  65 },
      c0: { l: 0.27, c: 0.020, h:  55 },
      c1: { l: 0.41, c: 0.018, h:  55 },
      c2: { l: 0.53, c: 0.015, h:  55 },
      c3: { l: 0.63, c: 0.012, h:  55 },
      c4: { l: 0.72, c: 0.010, h:  55 },
    },
  },
  {
    // Cool: a crisp white with a deep lapis-blue accent — clean and confident.
    id: 'Lapis',
    name: 'Lapis',
    version: 2,
    depth: 0.04,
    tokens: {
      a0: { l: 0.55, c: 0.17, h: 255 },
      a1: { l: 0.55, c: 0.17, h: 295 },
      a2: { l: 0.55, c: 0.17, h: 335 },
      a3: { l: 0.55, c: 0.17, h:  15 },
      a4: { l: 0.55, c: 0.17, h:  55 },
      b0: { l: 0.98, c: 0.006, h: 250 },
      b1: { l: 0.96, c: 0.008, h: 250 },
      b2: { l: 0.93, c: 0.010, h: 250 },
      b3: { l: 0.95, c: 0.008, h: 250 },
      b4: { l: 0.93, c: 0.010, h: 250 },
      c0: { l: 0.23, c: 0.018, h: 250 },
      c1: { l: 0.40, c: 0.016, h: 250 },
      c2: { l: 0.52, c: 0.014, h: 250 },
      c3: { l: 0.62, c: 0.012, h: 250 },
      c4: { l: 0.72, c: 0.010, h: 250 },
    },
  },
  {
    // Neutral anchor: a clean near-white with a deep botanical green accent.
    // Surfaces and text stay essentially neutral — the green lives in the accent,
    // not a wash over the whole UI.
    id: 'Flora',
    name: 'Flora',
    version: 2,
    depth: 0.06,
    tokens: {
      a0: { l: 0.55, c: 0.16, h: 150 },
      a1: { l: 0.55, c: 0.16, h: 190 },
      a2: { l: 0.55, c: 0.16, h: 230 },
      a3: { l: 0.55, c: 0.16, h: 270 },
      a4: { l: 0.55, c: 0.16, h: 310 },
      b0: { l: 0.98, c: 0.003, h: 150 },
      b1: { l: 0.96, c: 0.004, h: 150 },
      b2: { l: 0.93, c: 0.005, h: 150 },
      b3: { l: 0.95, c: 0.004, h: 150 },
      b4: { l: 0.93, c: 0.005, h: 150 },
      c0: { l: 0.25, c: 0.005, h: 150 },
      c1: { l: 0.40, c: 0.005, h: 150 },
      c2: { l: 0.52, c: 0.004, h: 150 },
      c3: { l: 0.62, c: 0.004, h: 150 },
      c4: { l: 0.72, c: 0.003, h: 150 },
    },
  },
  {
    // Warm: warm off-white paper with a cool ink-blue accent — paper meets pen.
    id: 'Paper',
    name: 'Paper',
    version: 2,
    depth: 0.05,
    tokens: {
      a0: { l: 0.50, c: 0.13, h: 250 },
      a1: { l: 0.50, c: 0.13, h: 290 },
      a2: { l: 0.50, c: 0.13, h: 330 },
      a3: { l: 0.50, c: 0.13, h:  10 },
      a4: { l: 0.50, c: 0.13, h:  50 },
      b0: { l: 0.985, c: 0.006, h:  75 },
      b1: { l: 0.965, c: 0.007, h:  75 },
      b2: { l: 0.935, c: 0.008, h:  75 },
      b3: { l: 0.955, c: 0.007, h:  75 },
      b4: { l: 0.935, c: 0.008, h:  75 },
      c0: { l: 0.22, c: 0.008, h:  70 },
      c1: { l: 0.40, c: 0.007, h:  70 },
      c2: { l: 0.52, c: 0.006, h:  70 },
      c3: { l: 0.62, c: 0.005, h:  70 },
      c4: { l: 0.72, c: 0.004, h:  70 },
    },
  },
  {
    // Cool: a pale violet-grey with a rich plum accent — soft, refined, distinct.
    id: 'Decepticon',
    name: 'Decepticon',
    version: 2,
    depth: 0.06,
    tokens: {
      a0: { l: 0.52, c: 0.18, h: 295 },
      a1: { l: 0.52, c: 0.18, h: 335 },
      a2: { l: 0.52, c: 0.18, h:  15 },
      a3: { l: 0.52, c: 0.18, h:  55 },
      a4: { l: 0.52, c: 0.18, h:  95 },
      b0: { l: 0.98, c: 0.006, h: 295 },
      b1: { l: 0.96, c: 0.008, h: 295 },
      b2: { l: 0.93, c: 0.010, h: 295 },
      b3: { l: 0.95, c: 0.008, h: 295 },
      b4: { l: 0.93, c: 0.010, h: 295 },
      c0: { l: 0.23, c: 0.014, h: 295 },
      c1: { l: 0.40, c: 0.012, h: 295 },
      c2: { l: 0.52, c: 0.010, h: 295 },
      c3: { l: 0.62, c: 0.008, h: 295 },
      c4: { l: 0.72, c: 0.006, h: 295 },
    },
  },
] as const satisfies readonly ThemeV2[];

type DefaultTheme = (typeof DEFAULT_THEMES)[number]['id'];
